import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Thin from "./TicketThin.woff2";

export const TicketThinFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: Thin },
];
